import { Gallery } from "~/components/Gallery/Gallery";
import * as React from 'react';
export default {
  Gallery,
  React
};